<template>
    <v-card class="rounded-lg" id="recordings">
        <v-card-title>
            Recordings
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <!-- <v-alert type="info" color="primary">For security, recording links expire within 72 hours. If a download link is expired, just click the Renew button to get a new secure link.</v-alert> -->
            <v-simple-table v-if="recordings.length">
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th>Timestamp</th>
                            <th>Room</th>
                            <th></th>
                            <!-- <th>Renew Link</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="recording in recordings" :key="recording.ID">
                            <td style="white-space:nowrap;">{{formatRecordingDate(recording)}}</td>
                            <td style="white-space:nowrap;">{{recording.post_title}}</td>
                            <!-- <td class="truncate-text" v-html="recordingUrl(recording)"></td> -->
                            <!-- <td v-html="recordingUrl(recording)"></td> -->
                            <td style="white-space: nowrap;">
                                <v-btn @click="renewDownloadLink(recording, true)" icon x-small title="Play"><v-icon>mdi-play-circle-outline</v-icon></v-btn>
                                <!-- <v-btn class="ml-2" :href="recordingUrl(recording)" target="_blank" icon x-small title="Download"><v-icon>mdi-cloud-download-outline</v-icon></v-btn> -->
                                <v-btn class="ml-2" @click="renewDownloadLink(recording)" target="_blank" icon x-small title="Download"><v-icon>mdi-cloud-download-outline</v-icon></v-btn>
                                <v-btn class="ml-2" title="Copy URL" x-small icon @click="copyURL(recordingUrl(recording))"><v-icon>mdi-content-copy</v-icon></v-btn>
                                <v-btn class="ml-2" title="Delete" x-small icon @click="confirmDeleteRecording(recording)"><v-icon>mdi-close-circle</v-icon></v-btn>
                            </td>
                            <!-- <td>
                                <v-btn x-small @click="renewDownloadLink(recording)" :loading="renewing.includes(recording.ID)">Renew</v-btn>
                            </td> -->
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
            <div v-else class="text-h5 text--disabled text-center">No Recordings</div>
            <v-dialog v-model="watch_dialog" id="video_player">
                <v-card>
                    <v-toolbar>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="closeVideoPlayer()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text class="video-container">
                        <v-responsive aspect-ratio="16/9" style="text-align:center;">
                            <video 
                                v-if="watch_video_url"
                                controls 
                                style="max-height: 70vh;" 
                                :src="watch_video_url" 
                                type="video/webm">
                            </video>
                        </v-responsive>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog v-model="confirm_delete_recording">
                <v-card width="300">
                    <!-- <v-toolbar>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="confirm_delete_recording = null">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar> -->
                    <v-card-text>
                        <div class="mt-8 mx-8">Are you sure?</div>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="confirm_delete_recording = null">Cancel</v-btn>
                        <v-btn color="red" @click="deleteRecording()" class="ml-2" :loading="deleting">Delete</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card-text>
    </v-card>
</template>

<script>
import { useUserStore } from '../../stores/user'

export default {
    name: 'Recordings',
    created: function() {
        // this.app = useAppStore()
        this.user = useUserStore()
    },
    data: function() {
        return {
            app: null,
            user: null,
            recordings: [],
            renewing: [],
            watch_dialog: false,
            watch_video_url: null,
            confirm_delete_recording: null,
            recording_to_delete: null,
            deleting: false
        }
    },
    mounted: function() {
        this.loadRecordings()
    },
    methods: {
        closeVideoPlayer: function() {
            this.watch_dialog = false
            this.watch_video_url = null
        },
        recordingUrlHtml: function(post) {
            let data = JSON.parse(post.post_content)
            let url = data.data.recording_presigned_url.replace(/&amp;/g, '&')
            return `<a href="${url}" target="_blank">Download</a>`
        },
        recordingUrl: function(post) {
            let data = JSON.parse(post.post_content)
            
            // First try to use our custom S3 URL if available
            if (post.s3_url) {
                return post.s3_url.replace(/&amp;/g, '&')
            }
            
            // Then try to use the S3 URL from the data if available
            if (data?.data?.s3_presigned_url) {
                return data.data.s3_presigned_url.replace(/&amp;/g, '&')
            }
            
            // Check for local URL if S3 is not available
            if (data?.data?.local_url) {
                return data.data.local_url.replace(/&amp;/g, '&')
            }
            
            // Fall back to the original 100ms URL
            let url = data?.data?.recording_presigned_url?.replace(/&amp;/g, '&') ?? ''
            return url
        },
        formatRecordingDate: function(recording) {
            let data = JSON.parse(recording.post_content)
            const localDate = moment(data.timestamp).local();
            const formattedDate = localDate.format('MMM D, YYYY h:mmA'); // "Nov 22, 2023 5:32PM"
            return formattedDate
        },
        loadRecordings: function() {
            this.loading = true
            this.user.app.get('meeting/recordings').then(response => {
                this.recordings = response.data.recordings
                this.loading = false
            })
            .catch(error => {
                console.error(error)
                this.loading = false
            })
        },
        renewDownloadLink: function(recording, watch = false) {
            let id = recording.ID
            this.renewing.push(id)
            this.user.app.get(`meeting/renew_download_url/${id}`)
            .then(response => {
                // console.log('new url', response.data.url)
                // this.recordings = response.data.recordings
                // let url = this.recordingUrl(recording)
                if(!watch)
                    this.triggerDownload(response.data.url)
                else
                    this.watch(response.data.url)
            })
            .catch(error => {
                console.error(error)
            })
            .finally(() => {
                this.renewing = this.renewing.filter(item => item !== id)
            })
        },
        triggerDownload: function(url) {
            // Create an anchor tag (<a>) and set its properties
            const a = document.createElement('a')
            a.href = url
            a.setAttribute('download', 'Recording') // You can also set a filename by passing it to the download attribute
            a.setAttribute('target', '_blank')
            document.body.appendChild(a) // Append the anchor tag to the document
            a.click() // Simulate a click on the anchor tag
            document.body.removeChild(a) // Remove the anchor tag from the document
        },
        async copyURL(text) {
            try {
                await navigator.clipboard.writeText(text);
                this.user.app.showSuccess("Copied to clipboard!")
            } catch($e) {
                console.error($e)
            }
        },
        watch: function(url) {
            // let data = JSON.parse(post.post_content)
            // let url = data.data.recording_presigned_url.replace(/&amp;/g, '&')
            // this.watch_video_url = data.data.recording_presigned_url.replace(/&amp;/g, '&')
            this.watch_video_url = url
            this.watch_dialog = true
        },
        confirmDeleteRecording: function(recording) {
            this.recording_to_delete = recording
            this.confirm_delete_recording = true
            console.log(recording)
        },
        deleteRecording() {
            console.log("delete", this.recording_to_delete)
            this.deleting = true
            let id = this.recording_to_delete.ID
            this.user.app.delete(`meeting/recording/${id}`)
            .then(response => {
                console.log("Delete response:", response)
                this.recordings = response.data.recordings
                this.confirm_delete_recording = null
                this.user.app.showSuccess("Recording deleted successfully")
            })
            .catch(error => {
                console.error("Delete error:", error)
                let errorMessage = error?.response?.data?.message || 
                                  error?.response?.data || 
                                  'An unknown error occurred'
                
                this.user.app.showError('Error deleting recording: ' + errorMessage)
                
                // Check if we have the recordings in the error response
                if (error?.response?.data?.recordings) {
                    this.recordings = error.response.data.recordings
                }
            })
            .finally(() => {
                this.deleting = false
                this.recording_to_delete = null
            })
        }
    }
}
</script>

<style>
.truncate-text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.v-dialog {
    width: auto !important;
}
</style>